import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '前列腺健康知识科普',
  url: 'https://prostate-health-guide.readdy.ai',
  description: '深度解析前列腺高潮的生理原理、刺激方式与安全注意事项，帮助成年男性全面了解前列腺高潮的体验机制、健康益处及正确操作方法。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://prostate-health-guide.readdy.ai/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="前列腺高潮完全指南：原理、方法与安全须知"
        description="深度解析前列腺高潮的生理原理、刺激方式与安全注意事项，帮助成年男性全面了解前列腺高潮的体验机制、健康益处及正确操作方法，科学、专业、负责任地提供实用指导。"
        keywords="前列腺高潮,前列腺按摩方法,男性前列腺刺激,前列腺高潮技巧,前列腺健康,男性性健康指南,前列腺高潮注意事项"
        canonicalUrl="https://prostate-health-guide.readdy.ai"
        ogType="website"
        schema={homeSchema}
      />
      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />
      <CTASection />
    </>
  );
}